<template>
  <div>
    <div class="rel-grid-container" :style="{'max-width': chapter_id>0? '100%': '75%'}">
      <div id="top-div"></div>
      <div style="margin: 50px auto;">
        <b-form-checkbox v-on:change="previousDatesChange" style="float: right;" v-model="permissions.previousDates">
            {{$t('dates.previous_dates')}}
          </b-form-checkbox>
        <b-table  class="table-hover-new" small bordered :items="dates" :fields="fields" v-on:row-clicked="editDate" :tbody-tr-class="rowClass">
          <template v-slot:cell(delete)="data" >
               <b-form-checkbox v-if="data.item.attendance==0" class="fit-width" style="margin:auto;" v-model="data.item.delete" :value="1" :unchecked-value="0">
              </b-form-checkbox>
           </template>
           <template v-slot:cell(type)="data" >
               {{$t('dates.date_type'+data.item.type)}}
           </template>
           <template v-slot:cell(meeting_mode)="data" >
               {{data.item.meeting_mode==0?  $t('general.hybrid_text') : (data.item.meeting_mode==1? $t('general.online_text') : $t('general.inperson_text'))}}
           </template>
           <template v-slot:cell(note)="data" >
               <span v-html="data.item.note"></span>
           </template>
           <template v-slot:cell(day)="data" >
               {{$d(new Date(data.item.day.split("-").join("/") + " 00:01"), 'short')}}
           </template>
           <template v-slot:cell(speakers)="data" >
            <div style="display:grid;grid-gap:20px;">
               <div v-for="speaker in data.item.speakers" :key="speaker.name" >
                  <div>{{speaker.name}}</div>
                  <div>{{speaker.company}}</div>
               </div>
               </div>
           </template>
          </b-table>
      </div>
     <b-alert variant="success" dismissible :show="showSuccess"  @dismissed="showSuccess=false">
        {{$t('attendance.export_success')}}
        </b-alert>
        <b-alert variant="warning" dismissible :show="showExportAlert"  @dismissed="showExportAlert=false">
        {{$t('attendance.export_failure')}}
        </b-alert>
      <div class="submit-box-2">
        <b-button v-if="dates.filter(v=>v.delete==1).length>0" class="submit-button4" v-on:click="showDatesDelete=true;" variant="clear-blue"><div class="delete-button"></div><span>{{$t('global.button_delete')}}</span></b-button>
        <b-button v-if="permissions.access" class="submit-button4" v-on:click="newDate" variant="clear-blue"><div class="new-button"></div><span>{{$t('global.button_new')}}</span></b-button>
        <div style="display:grid; grid-template-columns: max-content max-content; margin: auto;" class="fit-width">
            <b-button class="submit-button4" style="margin:auto;" v-if="!showSuccess" v-on:click="getScheduleExport" variant="clear-blue"><div class="import-button"></div><span>{{$t('global.button_export')}}</span></b-button>
            <div v-if="exportFile.filename.length>0 && showSuccess" style="margin:auto;" class="fit-width"> 
                <b-button class="submit-button4" v-on:click="downloadScheduleExport" variant="clear-blue" ><div class="import-button"></div><span>{{$t('attendance.download_export')}}</span></b-button>
                <a id="export-file" :download="exportFile.filename" :href="exportFile.content" hidden></a>
            </div>
        </div>
      </div>
      <div class="div-space"></div>
    </div>
    <b-modal id="slide-modal" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true"  centered :title="$t(dateEdit.id>0? 'dates.edit_date' : 'dates.new_date')" v-model="showDateEdit">
        <div>
            <span class="form-box-title">{{$t('dates.meeting_date_and_time')}}</span>
            <div class="form-box" style="grid-template-columns:max-content auto auto;">
                <span v-if="isCorporateConnections" class="form-box-name">{{$t('dates.type_text')}}</span>
                <b-form-select v-if="isCorporateConnections" v-model="dateEdit.type" :options="typeOptions" class="mb-3 form-box-input" required />
                <span v-if="isCorporateConnections"  class="form-box-name">{{$t('general.meeting_mode')}}</span>
                <b-form-checkbox-group v-if="isCorporateConnections" class="form-box-input" style="margin: auto 0;text-align:left;" v-model="dateEdit.meeting_mode" :options="meetingModes">
                </b-form-checkbox-group>
                <span class="form-box-name">{{$t('announcement.date_text')}}</span>
                 <b-form-datepicker style="margin: 5px 0px;" class="form-box-input" :date-disabled-fn="dateDisabled" :state="dateEdit.day != null" v-model="dateEdit.day" :locale="$i18n.locale"></b-form-datepicker>
                <span class="form-box-name">{{$t('general.meeting_start_networking')}}</span>
                <b-form-timepicker minutes-step="5" :label-no-time-selected="$t('global.no_time')"  class="form-box-input time-picker" :state="dateEdit.meet_pre_start != null" v-model="dateEdit.meet_pre_start" :locale="$i18n.locale" required></b-form-timepicker>
                <span class="form-box-name">{{$t('general.meeting_start_time')}}</span>
                <b-form-timepicker minutes-step="5" :label-no-time-selected="$t('global.no_time')" class="form-box-input time-picker" @input="setEndTime" :state="dateEdit.meet_start != null" v-model="dateEdit.meet_start" :locale="$i18n.locale" required></b-form-timepicker>
                <span class="form-box-name">{{$t('general.end_time')}}</span>
                <b-form-timepicker minutes-step="5" :label-no-time-selected="$t('global.no_time')" class="form-box-input time-picker" :state="dateEdit.meet_end != null"  v-model="dateEdit.meet_end" :locale="$i18n.locale"></b-form-timepicker>
                <span v-if="!isCorporateConnections || (dateEdit.meeting_mode!=2)" class="form-box-name">{{$t('dates.meeting_link')}}</span>
                <b-form-input v-if="!isCorporateConnections || (dateEdit.meeting_mode!=2)" v-model="dateEdit.meeting_link" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" max="255" class="form-box-input"></b-form-input>
                <span v-if="!isCorporateConnections || (dateEdit.meeting_mode!=1)" class="form-box-name">{{$t('dates.location_text')}}</span>
                <b-form-textarea v-if="!isCorporateConnections || (dateEdit.meeting_mode!=1)" v-model="dateEdit.address" :rows="3" style="min-width:300px;border-radius:15px;" class="form-box-input" :placeholder="$t('dates.location_placeholder')"/>
                <span v-if="!isCorporateConnections || (dateEdit.meeting_mode!=1)" style="grid-column:2/4;text-align:right;font-size:12px;">*{{$t('dates.address_note')}}</span>
                <span class="form-box-name">{{$t('dates.note_text')}}</span>
                <BaseEditor class="form-box-input" :content="dateEdit" :smallFormat="true" />
            </div>
            <div v-if="event_chapter" >
              <span class="form-box-title">{{$t('dates.event_info')}}</span>
              <div class="form-box " style="grid-template-columns:auto;position:relative;">
                <span class="form-box-name">{{$t('dates.title_text')}}</span>
                <b-form-input v-model="dateEdit.title" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" max="255" class="form-box-input"></b-form-input>
                  <ImageSelector style="grid-column:1/4;" ref="imageSelector" :imageObject="dateEdit" :circular="false"/>
              </div>
            </div>
             <b-alert variant="danger" dismissible :show="showAlert" @dismissed="showAlert=false" style="margin: auto;" class="fit-width">
              {{alertText}}
              </b-alert>
            </div>
        <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showDateEdit=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="updateDate" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_save')}}</span></b-button>
        </div>
    </b-modal>
    <b-modal id="slide-modal" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true"  centered :title="$t('dates.new_date')" v-model="showDateNew">
        <div>
          <div v-if="isCorporateConnections && permissions.organization.is_parent && chapter_id==0" style="display:grid; grid-template-columns: auto auto;">
            <span  class="form-box-name">{{$t('dates.chapter_text')}}</span>
            <b-form-select v-model="dateEdit.org" :options="chapterOptions" class="mb-3 form-box-input" value-field="id" text-field="name" required @change="orgChange"/>
          </div>
          <div v-if="!permissions.organization.is_parent || dateEdit.org>0 || chapter_id>0">
          <span class="form-box-title">{{$t('dates.meeting_dates')}}</span>
            <div class="form-box" style="grid-template-columns: repeat(1,max-content);">
              <div v-for="day in dateEdit.days" :key="day" style="display:grid; grid-template-columns: repeat(2,max-content);">
                <b-form-datepicker style="margin: 5px 0px;" :state="day.day != null" :date-disabled-fn="dateDisabled" v-model="day.day" :locale="$i18n.locale"></b-form-datepicker>
                  <b-button v-if="dateEdit.days.length>1" style="margin: auto 0;" class="submit-button4" v-on:click="removeDate(day)" variant="clear-blue"><div class="close-button"></div></b-button>
                </div>
                <b-button class="submit-button4" v-on:click="addDay" variant="clear-blue"><div class="plus-button"></div></b-button>
            </div>
            <span class="form-box-title">{{$t('general.meeting_time')}}</span>
            <div class="form-box" style="grid-template-columns: max-content auto auto;">
               <span v-if="isCorporateConnections" class="form-box-name">{{$t('dates.type_text')}}</span>
                <b-form-select v-if="isCorporateConnections" v-model="dateEdit.type" :options="typeOptions" class="mb-3 form-box-input" required />
                <span v-if="isCorporateConnections"  class="form-box-name">{{$t('general.meeting_mode')}}</span>
                <b-form-checkbox-group v-if="isCorporateConnections" class="form-box-input" style="margin: auto 0;text-align:left;" v-model="dateEdit.meeting_mode" :options="meetingModes">
                </b-form-checkbox-group>
                <span class="form-box-name">{{$t('general.meeting_start_networking')}}</span>
                <b-form-timepicker minutes-step="5" :label-no-time-selected="$t('global.no_time')"  class="form-box-input time-picker" :state="dateEdit.meet_pre_start != null" v-model="dateEdit.meet_pre_start" :locale="$i18n.locale" required></b-form-timepicker>
                <span class="form-box-name">{{$t('general.meeting_start_time')}}</span>
                <b-form-timepicker minutes-step="5" :label-no-time-selected="$t('global.no_time')" class="form-box-input time-picker" @input="setEndTime" :state="dateEdit.meet_start != null" v-model="dateEdit.meet_start" :locale="$i18n.locale" required></b-form-timepicker>
                <span class="form-box-name">{{$t('general.end_time')}}</span>
                <b-form-timepicker minutes-step="5" :label-no-time-selected="$t('global.no_time')" class="form-box-input time-picker" :state="dateEdit.meet_end != null"  v-model="dateEdit.meet_end" :locale="$i18n.locale"></b-form-timepicker>
                <span class="form-box-name">{{$t('dates.meeting_link')}}</span>
                <b-form-input v-model="dateEdit.meeting_link" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" max="255" class="form-box-input"></b-form-input>
                <span class="form-box-name">{{$t('dates.location_text')}}</span>
                <b-form-textarea v-model="dateEdit.address" :rows="3" style="min-width:300px;border-radius:15px;" class="form-box-input" :placeholder="$t('dates.location_placeholder')"/>
                <span style="grid-column:2/4;text-align:right;font-size:12px;">*{{$t('dates.address_note')}}</span>
                <span class="form-box-name">{{$t('dates.note_text')}}</span>
                <BaseEditor class="form-box-input" :content="dateEdit" :smallFormat="true" />
            </div>

            <div v-if="event_chapter" >
              <span class="form-box-title">{{$t('dates.event_info')}}</span>
              <div class="form-box " style="grid-template-columns:auto;position:relative;">
                <span class="form-box-name">{{$t('dates.title_text')}}</span>
                <b-form-input v-model="dateEdit.title" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" max="255" class="form-box-input"></b-form-input>
                  <ImageSelector style="grid-column:1/4;" ref="imageSelector" :imageObject="dateEdit" :circular="false"/>
              </div>
            </div>
             <b-alert variant="danger" dismissible :show="showAlert" @dismissed="showAlert=false" style="margin: auto;" class="fit-width">
              {{alertText}}
              </b-alert>
            </div>
            </div>
        <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showDateNew=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-show="!permissions.organization.is_parent || dateEdit.org>0 || chapter_id>0" v-on:click="createDates" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_save')}}</span></b-button>
        </div>
    </b-modal>
    <b-modal centered :title="$t('dates.delete_title')" v-model="showDatesDelete">
        <div>
          {{$t('dates.delete_text', {dates: dates.filter(v=>v.delete==1).length})}}
           <br/>
           <br/>
          <div v-if="dates.filter(v=>v.delete==1 && v.speakers.length>0).length>0">{{$t('dates.delete_speakers')}}:</div>
          <div v-for="date in dates.filter(v=>v.delete==1 && v.speakers.length>0)" :key="date.id">{{$d(new Date(date.day.split("-").join("/") + " 00:01"), 'short')}}</div>
        </div>
        <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showDatesDelete=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="deleteDate" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_confirm')}}</span></b-button>
        </div>
    </b-modal>
  </div>
</template>
<style scoped>
 
</style>
<script>
    
    export default {
      name: "Dates",
      data() {
        return {
          event_chapter: false,
          showExportAlert: false,
          showSuccess: false,
          exportFile: {filename: '', content: ''},
          chapterOptions: [],
          typeOptions: [{value: 0, text: this.$t('dates.date_type0')},{value: 1, text: this.$t('dates.date_type1')},{value: 2, text: this.$t('dates.date_type2')},{value: 3, text: this.$t('dates.date_type3')}],
          dates: [],
          fields: [
            {
              key: 'delete',
              label: this.$t('dates.select_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'day',
              label: this.$t('dates.date_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'meet_start_text',
              label: this.$t('dates.start_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            }
          ],
          dateEdit: {org:0,id: 0, day: null, meet_pre_start: null, meet_start: null, meet_end: null, days: [], type: 0, note: '', text:'', update: '',meeting_mode: 1, meeting_link:"", address: "", title: "", photo: null},
          showDateEdit: false,
          showAlert: false,
          alertText: '',
          showDatesDelete: false,
          next_meeting: '',
          showDateNew: false,
          meeting_days: [],
          meetingModes: [{value: 1, text: this.$t('general.online_text')},{value: 2, text: this.$t('general.inperson_text')},{value: 0, text: this.$t('general.hybrid_text')}],
        }
      },
      watch: {
      '$i18n.locale': {
        handler: function () {
          this.getDates();
        }
      }
    },
    
      props:{
        chapter_id: {type: Number, default: 0}
      },
    methods: {
      setEndTime(){
        if(this.dateEdit.meet_start){
          var d = new Date("2020-01-01 "+this.dateEdit.meet_start);
          d.setMinutes(d.getMinutes()+90);
          this.dateEdit.meet_end = d.getHours()+":"+d.getMinutes();
        }
        
      },
      orgChange(){
        this.meeting_days = this.dates.filter(v => v.org == this.dateEdit.org || v.org == 0).map(v => v.day);
      },
       dateDisabled(ymd, date) {
         
        if(this.meeting_days.length>0){
          return this.meeting_days.includes(ymd);
        }
        return false;
      },
      addDay(){
        this.dateEdit.days.push({day: null});
      },
      removeDate(day){
        this.dateEdit.days = this.dateEdit.days.filter(v => v.day != day.day);
      },
      rowClass(item) {
        if(this.chapter_id==0 && this.permissions.organization.is_parent){
          return;
        }
        if (!item) return
        if (item.day == this.next_meeting) return 'blue-row'
      },
      
      previousDatesChange() {
        this.getDates();
      },
      getDates() {
        this.$http.post("/api/organization/startup/dates"+(this.chapter_id>0? "/aschild" : ""), {getprevious: this.permissions.previousDates, org: this.chapter_id}).then((response) => {
          if (response.data.success) {
            this.event_chapter = response.data.event_chapter==1;
            this.meeting_days = [];
            for(var i=0; i<response.data.dates.length; i++){
              response.data.dates[i].delete = 0;
              this.meeting_days.push(response.data.dates[i].day);
            }
            this.dates = response.data.dates;
          }
        }).catch(() => {
        });
      },
      deleteDate(){
          this.$http.post("/api/organization/startup/dates/delete", {dates: this.dates.filter(v=>v.delete==1)}).then((response) => {
          if (response.data.success) {
            this.dates = this.dates.filter(v=>v.delete==0);
            this.meeting_days = [];
            for(var i=0; i<this.dates.length; i++){
              thisdates[i].delete = 0;
              this.meeting_days.push(this.dates[i].day);
            }
          }
          this.showDatesDelete = false;
        }).catch(() => {
            this.showDatesDelete = false;
        });
      },
      createDates(){
        this.showAlert = false;
        var isDate = false;
        for(var i=0; i<this.dateEdit.days.length; i++){
          if(this.dateEdit.days[i].day != null){
            isDate = true;
          }
        }
          if(!isDate || this.dateEdit.meet_pre_start == null || this.dateEdit.meet_start == null || this.dateEdit.meet_end == null){
              this.showAlert = true;
              this.alertText = this.$t("global.complete_fields");
              return;
          }
          this.dateEdit.org= this.chapter_id>0? this.chapter_id: this.dateEdit.org;
          this.$http.post("/api/organization/startup/dates/create"+(this.dateEdit.org>0? "/aschild" : ""),  this.dateEdit).then((response) => {
            if (response.data.success) {
              this.getDates();
              this.showDateNew = false;
            }else{
                this.showAlert = true;
                this.alertText = this.$t("dates.date_in_use");
                return;
            }
          }).catch(() => {
              this.showDateNew = false;
          });
      },
      updateDate(){
          this.showAlert = false;
          this.dateEdit.note = this.dateEdit.text;
          if(this.dateEdit.day == null || this.dateEdit.meet_pre_start == null || this.dateEdit.meet_start == null || this.dateEdit.meet_end == null){
              this.showAlert = true;
              this.alertText = this.$t("global.complete_fields");
              return;
          }
          this.dateEdit.org= this.chapter_id>0? this.chapter_id: this.dateEdit.org;
          this.$http.post("/api/organization/startup/dates/update"+(this.dateEdit.org>0? "/aschild" : ""),  this.dateEdit).then((response) => {
          if (response.data.success) {
            this.getDates();
            this.showDateEdit = false;
          }else{
              this.showAlert = true;
              this.alertText = this.$t("dates.date_in_use");
              return;
          }
        }).catch(() => {
             this.showDateEdit = false;
        });
      },
      getNextMeetingDate() {
        this.$http.post(this.chapter_id==0? "/api/organization/dates" : "/api/organization/dates/noauth", {org: this.chapter_id}).then((response) => {
          if (response.data.success === true) {
            this.next_meeting = response.data.next_formatted;
          }
        }).catch(() => {});
      },
      newDate() {
        this.showAlert = false;
        this.dateEdit = {org: 0,id: 0, type: 0, day: null, meet_pre_start: null, meet_start: null, meet_end: null, meeting_mode:1, meeting_link:"", days: [{day: null}], title: "", photo: null};
        if(this.dates.length>0){
          this.dateEdit.meet_pre_start = this.dates[0].meet_pre_start;
          this.dateEdit.meet_start = this.dates[0].meet_start;
          this.dateEdit.meet_end = this.dates[0].meet_end;
        }
        this.showDateNew = true;
      },
      editDate(item) {
        this.showAlert = false;
        this.dateEdit = Object.assign({}, item);
        this.dateEdit.update = this.dateEdit.text = this.dateEdit.note;
         this.showDateEdit = true;
      },
      getChapters(){
        this.$http.post("/api/organization/get/children/select", {}).then((response) => {
          if (response.data.success) {
            this.chapterOptions = response.data.children;
            this.chapterOptions.unshift({id: 0, name: this.$t('region.select_chapter')});
          }
        }).catch(() => {
        });
      },
      getScheduleExport(){
        this.$http.post("/api/organization/startup/export"+(this.dateEdit.org>0? "/aschild" : ""), {getprevious: this.permissions.previousDates, org: this.chapter_id}).then((response) => {
          if (response.data.success === true) {
            this.exportFile = response.data.file;
            this.showSuccess = true;
          }else{
            this.showExportAlert = true;
          }
        }).catch(() => { });
      },
      downloadScheduleExport(){
        document.getElementById("export-file").click();
        this.showSuccess = false;
        this.showExportAlert = false;
      },
    },
    destroyed() {
      this.removeClass(document.getElementById("menu-dates"), "active-menu");
     this.removeClass(document.getElementById("menu-chapter"), "active-menu");
    },
    mounted() {
       if(this.$route.params.id){
        this.chapter_id = this.$route.params.id;
      }
      this.fields =  [
            {
              key: 'delete',
              label: this.$t('dates.select_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'day',
              label: this.$t('dates.date_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'meet_start_text',
              label: this.$t('dates.start_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            }
          ];
           if(this.isCorporateConnections){
             this.fields = [
            {
              key: 'delete',
              label: this.$t('dates.select_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'day',
              label: this.$t('dates.date_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'type',
              label: this.$t('dates.type_text'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'meeting_mode',
              label: this.$t('general.meeting_mode'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'note',
              label: this.$t('dates.note_text'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'meet_start_text',
              label: this.$t('dates.start_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            },
            {
              key: 'speakers',
              label: this.$t('dates.speakers_header'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            }
          ]
             if(this.permissions.organization.is_parent){
               this.fields.unshift( {
              key: 'chapter_name',
              label: this.$t('dates.chapter_text'),
              thStyle: { "background-color":  process.env.VUE_APP_TABLE_HEADER,"color": "#ffffff"}
            });
             }
           }
     this.addClass(document.getElementById("menu-dates"), "active-menu");
      this.addClass(document.getElementById("menu-chapter"), "active-menu");
      this.getNextMeetingDate();
      this.getDates();
      this.getChapters();
    }
    }
</script>
